import { FC } from 'react';
import withResponsive from 'v3/common/hooks/withResponsive';
import Mobile from './mobile';
import Web from './web';
const ResponsiveComponent = withResponsive(Mobile, Web);

const LaunchSteps: FC = () => {
  return <ResponsiveComponent />;
};

export default LaunchSteps;
